// AutoTextField.js
import React, { useEffect, useRef, useState } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { AppWord } from "../value/AppConst";

const defaultFilterOptions = createFilterOptions();

function findItem(list, value, valueKey) {
    if(!list) return null;
    for(let i=0; i<list.length; i++) {
        if(list[i][valueKey] === value) {
            return list[i];
        }
    }
    return null;
}

export default function AutoTextField({
    dict, // {id, label, ...., valueKey, labelKey}
    value,
    list,
    onChange,
    onSelectRecord,
    disabled,
    size,
    style,
    onInputChange,
    hideLabel,
    listBoxProps,
    usePortal,
}) {
    const [itemFound, setItemFound] = useState(null);
    const [open, setOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [hasTypedInput, setHasTypedInput] = useState(false);
    const filteredOptionsRef = useRef([]);
    //const [slotProps, setSlotProps] = useState(undefined);

    const valueKey = dict.valueKey || dict.id;
    const labelKey = dict.labelKey || 'label';

    /* useEffect(() => {
        if(listBoxProps) setSlotProps({listbox: listBoxProps});
        else setSlotProps(undefined);
    }, [listBoxProps]); */

    useEffect(()=>{
        if(value !== undefined && value !== null && value !== '') {
            setItemFound((prev) => {
                // list가 내용은 같고 참조만 새로 바뀐 경우까지 itemFound를 새 객체로 바꾸면,
                // Autocomplete가 값이 바뀐 것으로 인식해 입력 중이던 텍스트를 선택값 라벨로
                // 덮어써버린다. 이미 같은 값을 가리키고 있다면 기존 참조를 유지한다.
                if(prev && prev[valueKey] === value) return prev;
                return findItem(list, value, valueKey);
            });
        }
        else {
            setItemFound(null);
        }
    }, [list, value, valueKey]);

    const getOptionLabel = (option) => {
        if(dict.getOptionLabel) return dict.getOptionLabel(option);
        return option[labelKey];
    };

    const onChangeValue = (e, value) => {
        if(value) {
            setItemFound(value);
            setOpen(false);
            setInputValue(getOptionLabel(value) || '');
            setHasTypedInput(false);
            onChange(dict.id, value[valueKey]);
            if(onSelectRecord) onSelectRecord(value);
        }
    }

    const onChangeText = (e, value, reason) => {
        setInputValue(value || '');
        if(reason === 'input') {
            setHasTypedInput((value || '').trim() !== '');
        }
        else {
            setHasTypedInput(false);
        }
        if(onInputChange) onInputChange(e, value, reason);
    };

    const onFilterOptions = (options, state) => {
        const filtered = dict.filterOptions
            ? dict.filterOptions(options, state)
            : defaultFilterOptions(options, state);
        filteredOptionsRef.current = filtered;
        return filtered;
    };

    const onKeyDown = (e) => {
        if(e.key !== 'Enter') return;

        const typedText = (inputValue || '').trim();
        if(!hasTypedInput || typedText === '') return;

        const filtered = filteredOptionsRef.current || [];
        if(filtered.length < 1) return;

        e.preventDefault();
        onChangeValue(e, filtered[0]);
    };

    const newStyle = style ? {...style} : {};
    if(!newStyle.minWidth) newStyle.minWidth = 100;
    if(!newStyle.fontSize) newStyle.fontSize = '0.85rem';
    if(!newStyle.backgroundColor) newStyle.backgroundColor = 'white';

    return(
        <Autocomplete
            options={list}
            filterOptions={onFilterOptions}
            size={size || AppWord.SMALL}
            getOptionLabel={getOptionLabel}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            onChange={onChangeValue}
            onInputChange={onChangeText}
            onKeyDown={onKeyDown}
            value={itemFound}
            clearOnEscape
            disabled={disabled}
            renderInput={
                (params) =>
                    <TextField {...params} label={hideLabel ? undefined : dict.label}
                        style={{fontSize: newStyle.fontSize}}
                    />
            }
            isOptionEqualToValue={(option, value) => option[valueKey] === value[valueKey]}
            style={newStyle}
            disablePortal={!usePortal}
            ListboxProps={listBoxProps || undefined}
            /* slotProps={slotProps} */
            sx={{
                '& + .MuiAutocomplete-popper .MuiAutocomplete-option .MuiAutocomplete-input .MuiAutocomplete-inputRoot': {
                    fontSize: '0.85rem',
                },
            }}
        />
    );
}